import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import dico from "../../lang/front.fr";

class LegalNotice extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            scroll: 'paper'
        }
    }


    handleClickOpen = scrollType => () => {
        this.setState({ open: true })
        this.setState({ open: scrollType })
    };

    handleClose = () => {
        this.setState({ open: false })
    }
    render() {
        const {  typeTexteDPO } = this.props
        return (
            <div>
                <span style={{ cursor: 'pointer' }} onClick={this.handleClickOpen('paper')}>{dico.login.legalNotice.title.text}</span>
                <Dialog
                    maxWidth={"md"}
                    open={this.state.open}
                    onClose={this.handleClose}
                    scroll={this.state.scroll}
                    aria-labelledby="scroll-dialog-title"
                >
                    <DialogTitle id="scroll-dialog-title">{dico.login.legalNotice.title.text}</DialogTitle>
                    <DialogContent dividers={this.state.scroll === 'paper'}>
                        <DialogContentText>
                            {typeTexteDPO === 1 &&
                                <div
                                    dangerouslySetInnerHTML={{ __html: dico.login.legalNotice.dpo1.text }}
                                >
                                </div>
                            }

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Fermer
          </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}
export default LegalNotice

